import React from 'react';

export default function NotFound() {
  return <h2>Page not found</h2>;
}
